var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mr-2",class:{'checkBox': _vm.mode==='normal', 'checkbox-large':_vm.mode==='large','checkbox-medium': _vm.mode==='medium'}},[_c('div',{class:{'selected': _vm.selected,'medium':_vm.mode==='medium', 'large':_vm.mode==='large'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }